import { IpRestrictionAddress } from '@treasury/domain/backoffice/services/access/entities/ip-restriction-address.entity';
import { UserTimeAccessDay } from '@treasury/domain/backoffice/services/access/entities/user-time-access-day.entity';
import { TmBaseComponent } from '@treasury/presentation';
import '@treasury/presentation/components/forms/tm-form';
import '@treasury/presentation/components/jh-ui/tm-button';
import { html } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import './partials/ip-access.component';
import './partials/time-access.component';

@customElement('tm-bo-ip-and-time-access')
export class CompanyUserIpAndTimeAccess extends TmBaseComponent {
    @property({ type: Array })
    public ipAddresses: IpRestrictionAddress[] = [];

    @property({ type: Boolean })
    public ipRestricted: boolean = false;

    @property({ type: Array })
    public timeAccessDays: UserTimeAccessDay[] = [];

    @property({ type: Boolean })
    public timeAccessRestricted: boolean = false;

    public render() {
        return html`
            <div class="flex flex-row gap-[80px]">
                <div class="flex flex-col gap-8">
                    <tm-bo-ip-access
                        class="flex-0"
                        .restricted=${this.ipRestricted}
                        .ipAddresses=${this.ipAddresses}
                    ></tm-bo-ip-access>
                </div>
                <div class="flex flex-col gap-8">
                    <div class="flex flex-col gap-6">
                        <tm-bo-time-access
                            class="flex-1"
                            .restricted=${this.timeAccessRestricted}
                            .timeAccessDays=${this.timeAccessDays}
                        ></tm-bo-time-access>
                    </div>
                </div>
            </div>
        `;
    }
}
